import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Movimenti from "./pages/Movimenti";
import Pricing from "./pages/Pricing";
import Settings from "./pages/Settings";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AutorizzaFatture from "./pages/AutorizzaFatture";
import SpidSimulazione from "./pages/SpidSimulazione";
import DelegaSuccesso from "./pages/DelegaSuccesso";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/accedi" element={<Login />} />
            <Route path="/registrati" element={<Register />} />
            <Route path="/piani" element={<Pricing />} />
            <Route path="/pagamento/successo" element={<PaymentSuccess />} />
            <Route path="/pagamento/annullato" element={<PaymentCancel />} />
            <Route path="/password-dimenticata" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/autorizza-fatture" element={<ProtectedRoute requireOnboarded><AutorizzaFatture /></ProtectedRoute>} />
            <Route path="/spid-simulazione" element={<ProtectedRoute requireOnboarded><SpidSimulazione /></ProtectedRoute>} />
            <Route path="/delega/successo" element={<ProtectedRoute requireOnboarded><DelegaSuccesso /></ProtectedRoute>} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute requireOnboarded><Dashboard /></ProtectedRoute>} />
            <Route path="/movimenti" element={<ProtectedRoute requireOnboarded><Movimenti /></ProtectedRoute>} />
            <Route path="/impostazioni" element={<ProtectedRoute requireOnboarded><Settings /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
